import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const GallerySection = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 3500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } }
    ]
  };

  const galleryItems = [5, 6, 7, 8];

  return (
    <section className="gallery-section-two p-0">
      <div className="carousel-outer">
        <Slider {...settings} className="gallery-carousel-two">
          {galleryItems.map((item, index) => (
            <div className="gallery-item-two" key={index}>
              <div className="image-box">
                <figure className="image">
                  <a
                    className="lightbox-image"
                    href={`/assets/images/resource/gallery-${item}.jpg`}
                  >
                    <img
                      src={`/assets/images/resource/gallery-${item}.jpg`}
                      alt={`Gallery ${item}`}
                    />
                  </a>
                </figure>
                <div className="caption-box">
                  <h4 className="title">
                    <a href="page-service-details.html">
                      Canada Immigration Rules
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <div className="call-to-action">
        <div className="auto-container">
          <div className="inner-container">
            <h5 className="title">
              Vize Başvurusu mu Arıyorsunuz? Hemen Arayın!
            </h5>
            <a className="info-btn" href="tel:+928800683000">
              <i className="fa fa-phone"></i> +92 (8800) 6830 00
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;